<template>
  <nav class="sidebar" :class="{ toggled: !visible }">
    <div class="sidebar-content ">
      <router-link :to="{ name: 'home' }">
        <!-- <img
          src="http://www.layer7tecnologia.net.br/l7logo.png"
          alt=""
          width="200"
          height="70"
        /> -->

        <img
          src="../assets/Logo--Looking-Glass.png"
          alt=""
          width="200"
          height="70"
        />
      </router-link>

      <ul class="sidebar-nav">
        <li class="sidebar-header"></li>

        <li class="sidebar-item">
          <a href="#lg" data-toggle="collapse" class="sidebar-link collapsed">
            <span class="align-middle">Looking Glass</span>
          </a>
          <ul id="lg" class="sidebar-dropdown list-unstyled collapse show">
            <router-link
              class="sidebar-item"
              :to="{ name: 'Home' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Consultar no Looking Glass</a>
            </router-link>

            <!-- <router-link
              class="sidebar-item"
              :to="{ name: 'fetchip' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Consultar IP BGP.NET</a>
            </router-link>

            <router-link
              class="sidebar-item"
              :to="{ name: 'fetchas' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Consultar ASN BGP.NET</a>
            </router-link> -->

            <!-- <router-link
              class="sidebar-item"
              :to="{ name: 'role.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Papeis de Usuários</a>
            </router-link> -->

            <!-- <router-link
              class="sidebar-item"
              :to="{ name: 'permission.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Permissões</a>
            </router-link> -->
          </ul>
        </li>

        <!-- <li class="sidebar-item">
          <a href="#crm" data-toggle="collapse" class="sidebar-link collapsed">
            <span class="align-middle">CRM</span>
          </a>
          <ul id="crm" class="sidebar-dropdown list-unstyled collapse">
            <router-link
              class="sidebar-item"
              :to="{ name: 'customer.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Clientes</a>
            </router-link>

            <router-link
              class="sidebar-item"
              :to="{ name: 'plan.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Planos</a>
            </router-link>

            <router-link
              class="sidebar-item"
              :to="{ name: 'payment.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Meios de Pagamento</a>
            </router-link>

            <router-link
              class="sidebar-item"
              :to="{ name: 'contract.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Contratos</a>
            </router-link>
          </ul>
        </li>

        <li class="sidebar-item">
          <a href="#frtm" data-toggle="collapse" class="sidebar-link collapsed">
            <span class="align-middle">FRTM</span>
          </a>
          <ul id="frtm" class="sidebar-dropdown list-unstyled collapse">
            <router-link
              class="sidebar-item"
              :to="{ name: 'feed.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">Feeds</a>
            </router-link>

            <router-link
              class="sidebar-item"
              :to="{ name: 'feedGroup.index' }"
              tag="li"
              active-class="active"
              exact
            >
              <a class="sidebar-link">BGP Communities</a>
            </router-link>
          </ul>
        </li> -->
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Sidebar",
  computed: {
    ...mapGetters({
      visible: "sidebar/visible"
    })
  }
};
</script>
